import appConfig from "@/app.config";

const appHost = window.location.hostname;
const envConfig = appConfig.ceviz.hosts[appHost];
const apiRoot = `${envConfig.protocol}://${appHost}:${envConfig.port}/${appConfig.ceviz.apiNamespace}`;

function buildUrl(resource, path) {
  return path ? `${apiRoot}/${resource}/${path}` : `${apiRoot}/${resource}`;
}

export function buildUsersUrl(path) {
  return buildUrl('users', path);
}
export function buildPropertiesUrl(path) {
  return buildUrl('properties', path);
}
export function buildAreasUrl(propertyId, path) {
  return buildUrl(`properties/${propertyId}/areas`, path);
}
export function buildItemsUrl(propertyId, areaId, path) {
  return buildUrl(`properties/${propertyId}/areas/${areaId}/items`, path);
}
export function buildQueryUrl(path) {
  return `${apiRoot}/${path}`;
}
export function buildOrderUrl(path) {
  return buildUrl('orders', path);
}
export function buildSendOtpUrl(path) {
  return buildUrl('otp', path);
}
export function buildVerifyOtpUrl() {
  return buildUrl('sessions/verify_otp');
}